import React from 'react';

function TsrAdminDashboardHome() {
  return (
    <div className="container-fluid py-4">
      <h4 className="mb-2">Welcome</h4>
      <p className="text-muted mb-0">Use the menu to manage food packages and related settings.</p>
    </div>
  );
}

export default TsrAdminDashboardHome;
